export default __webpack_public_path__ + "static/media/tropForestColored.656a1ab4.png";